// extracted by mini-css-extract-plugin
module.exports = {"ListOfForumsRight":"pu_a","ListOfForumsRight__brandDaysPosts":"pu_b bha_rq"};